import { AbstractControl, ValidatorFn } from '@angular/forms';

import { RequiredCheckResult } from '../interfaces/RequiredCheckResult';
import { DateValidationResult } from '../interfaces/DateValidationResult';
import { MinValidationResult } from '../interfaces/MinValidationResult';
import { MaxValidationResult } from '../interfaces/MaxValidationResult';
import { UniqueValidationResult } from '../interfaces/UniqueValidationResult';

/** @dynamic */
export abstract class AnjunaValidators {

    public static date(c: AbstractControl): DateValidationResult | null {
        if (!c.value) {
            return;
        }

        let isValid = true;

        // Handle obvious Invalid Date
        if (c.value.toString() === 'Invalid Date') {
            isValid = false;
            // Handle Moment Date
        } else if (typeof c.value._isValid === 'boolean') {
            isValid = c.value._isValid;
            // Handle Native Date
        } else {
            isValid = !isNaN(new Date(c.value).getTime());
        }

        if (isValid || c.value === '') {
            return null;
        } else {
            return {
                date: {
                    valid: false
                }
            };
        }
    }

    public static requiredCheck(c: AbstractControl): RequiredCheckResult | null {
        if (c.value) {
            return null;
        } else {
            return {
                required: {
                    valid: false
                }
            };
        }
    }

    public static unique(c: AbstractControl): UniqueValidationResult | null {
        if (!c.value || !Array.isArray(c.value)) {
            return;
        }

        const testArray = c.value.filter(Boolean);
        const isValid = testArray.length === Array.from(new Set(testArray)).length;

        if (isValid) {
            return null;
        } else {
            return {
                unique: {
                    valid: false
                }
            };
        }
    }

    public static minDate = (min: Date): ValidatorFn => {
        return (c: AbstractControl): MinValidationResult | null => {
            if (!c.value) {
                return;
            }

            if (c.value < new Date(min)) {
                return {
                    min: {
                        valid: false
                    }
                };
            } else {
                return null;
            }
        };
    }

    public static maxDate = (max: Date): ValidatorFn => {
        return (c: AbstractControl): MaxValidationResult | null => {
            if (!c.value) {
                return;
            }

            if (c.value > new Date(max)) {
                return {
                    max: {
                        valid: false
                    }
                };
            } else {
                return null;
            }
        };
    }
}
